import { defaultHttpClient } from 'shared/src/api/httpClient';
import type {
  FeedbackTitlesResponse,
  FeedbackType,
  SaveFeedbackResponse,
} from './types';

const getFeedbackTitles = ({
  feedbackType,
  goodsSno,
}: {
  feedbackType: FeedbackType;
  goodsSno: number;
}) => {
  return defaultHttpClient.request<FeedbackTitlesResponse>({
    method: 'GET',
    url: '/api/v2/feedback/titles/',
    params: {
      feedback_type: feedbackType,
      goods_sno: goodsSno,
    },
  });
};

const saveFeedback = ({
  goodsSno,
  feedbackSno,
}: {
  goodsSno: number;
  feedbackSno: number;
}) => {
  return defaultHttpClient.request<SaveFeedbackResponse>({
    method: 'POST',
    url: '/api/v2/feedback/goods/',
    data: {
      goods_sno: goodsSno,
      feedback_sno: feedbackSno,
    },
  });
};

const cancelFeedback = ({
  feedbackResultSno,
}: {
  feedbackResultSno: number;
}) => {
  return defaultHttpClient.request<void>({
    method: 'DELETE',
    url: `/api/v2/feedback/${feedbackResultSno}/`,
  });
};

export const feedbackService = {
  getFeedbackTitles,
  saveFeedback,
  cancelFeedback,
};
